import { useInfiniteQuery } from "@tanstack/react-query"
import { getIntentionRituals } from "../services/intention.service"
import type { IntentionFiltersState } from "../types"

export function useIntentionRituals(slug: string, filters: IntentionFiltersState) {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, error } =
    useInfiniteQuery({
      queryKey: ["intentionRituals", slug, filters],
      queryFn: ({ pageParam = 1 }) => getIntentionRituals(slug, filters, pageParam as number),
      getNextPageParam: lastPage =>
        lastPage.page < lastPage.totalPages ? lastPage.page + 1 : undefined,
      initialPageParam: 1,
      enabled: !!slug,
      staleTime: 5 * 60 * 1000,
    })

  const rituals = data?.pages.flatMap(page => page.rituals) ?? []
  const total = data?.pages[0]?.total ?? 0

  return {
    rituals,
    total,
    hasNextPage: !!hasNextPage,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    error,
  }
}
